<template>
  <!-- Table Container Card -->
  <b-card
    no-body
  >
    <div>
      <div class="m-2">
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <!-- Per Page -->
            <list-per-page
              :total="total"
              :current-per-page="perPage"
              @onChangePerPage="changePerPage"
            />
            <b-button
              variant="success"
              :disabled="excelSpinner"
              @click="downloadExcel"
            >
              <b-spinner
                v-if="excelSpinner"
                small
              />
              {{ $t('Download excel') }}
              <feather-icon icon="FileTextIcon" />
            </b-button>
          </b-col>
          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <list-search @onSearch="search" />
            </div>
          </b-col>
        </b-row>
      </div>
      <table-loader v-if="loader" />
      <messages-list
        v-else
        :fields="fields"
        :items="items"
        :sort-key="sortKey"
        :sort-type="sortType"
        :list-filters="additionalData.filters"
        :filters="filters"
        @onSortByChange="changeSortKey"
        @onSortDescChange="changeSortType"
        @onFilterChange="filterChange"
        @onFilterButtonClicked="getData"
      />
      <list-pagination
        :current="page"
        :current-per-page="perPage"
        :from="from"
        :to="to"
        :total="total"
        :total-page="totalPage"
        @onChangePage="changePage"
      />
    </div>
  </b-card>
</template>

<script>
import MessagesList from '../../components/messages/list/MessagesList'
import { ListIndex } from '../../common/mixins/list'

export default {
  components: {
    MessagesList,
  },
  mixins: [ListIndex],

  data() {
    return {
      routeName: 'messages',
      adminFields: [
        {
          key: 'account.name',
          label: this.$t('Account'),
        },
        {
          key: 'type',
          label: this.$t('Message Type'),
        },
        {
          key: 'body',
          label: this.$t('Message Body'),
        },
        {
          key: 'from',
          label: this.$t('Sender'),
        },
        {
          key: 'to',
          label: this.$t('Receiver'),
        },
        {
          key: 'status',
          label: this.$t('Status'),
        },
        {
          key: 'display_source',
          label: this.$t('Source'),
        },
        {
          key: 'retry_at',
          label: this.$t('Message retry at'),
          sortable: true,
        },
        {
          key: 'action',
          label: '',
        },
      ],
      userFields: [
        {
          key: 'account.name',
          label: this.$t('Account'),
        },
        {
          key: 'type',
          label: this.$t('Message Type'),
        },
        {
          key: 'body',
          label: this.$t('Message Body'),
        },
        {
          key: 'from',
          label: this.$t('Sender'),
        },
        {
          key: 'to',
          label: this.$t('Receiver'),
        },
        {
          key: 'status',
          label: this.$t('Status'),
        },
        {
          key: 'display_source',
          label: this.$t('Source'),
        },
        {
          key: 'retry_at',
          label: this.$t('Message retry at'),
          sortable: true,
        },
        {
          key: 'action',
          label: '',
        },
      ],
      sortKey: 'created_at',
      sortType: true,
    }
  },
  created() {
    if (this.$route.name === 'accounts-show') {
      this.customParams.account_id = this.$route.params.id
    }
  },
}
</script>

<style lang="scss">

</style>
